// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 471) return "chunks/oneds-analytics-js_077217740c853b5d4fe8.js";
	if (chunkId === 983) return "chunks/983_7ada0ad5b63711721274_[locale:b64b2e3f].js";
	if (chunkId === 472) return "chunks/custom-css-loader_1a842a9c4f88b364a295.js";
	if (chunkId === 939) return "chunks/gamepad-navigation_7b060136af316838da99.js";
	if (chunkId === 470) return "chunks/cxh_d3bdaa9e9c28b230f9d2.js";
	// return url for filenames based on template
	return undefined;
};